//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	let currentLocation = useContext(GlobalContext).getCurrentLocation;
	//#endregion

	//#region Style vars
	let display = 'flex';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	if (currentLocation() === 'index') {
		display = 'none';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: display,
				flexDirection: 'column',
				marginTop: mt ? '3rem' : 'unset',
			};
		},
		inputStyle: () => {
			return {
				width: 'initial',
			};
		},
		buttonStyle: () => {
			return {
				width: '6rem',
				textAlign: 'center',
				padding: '0.25rem',
			};
		},
	};
}

export default Styles;
